import { Icon } from '@shared/components/Icon/Icon';
import { IconVariants } from '@shared/components/Icon/IconMapper.ts';

import styles from './AccordionTabHeaderTemplate.module.scss';

export interface AccordionTabHeaderTemplateProps {
  iconVariant: IconVariants;
  accordionTitle: string;
  children?: React.ReactNode;
}

export function AccordionTabHeaderTemplate({ iconVariant, accordionTitle, children }: AccordionTabHeaderTemplateProps) {
  return (
    <>
      <Icon variant={iconVariant} iconAltText={`${accordionTitle} icon`} stylesClassName={'accordionIcon'} />
      <div className={styles.accordionTitleTextWrapper}>
        <p className={styles.accordionTitle}>{accordionTitle}</p>
        {children}
      </div>
    </>
  );
}
